const app_promo = {
  "app_promo.block_title": "<span>輕鬆享有</span> <span><em>安視優®會員</em></span> <span>獨家優惠</span>",
  "app_promo.li_01": "專屬福利",
  "app_promo.li_02": "消費積點",
  "app_promo.li_03": "點數兌獎",
  "app_promo.cta_title": "新會員馬上領 $100 購物金",
  "app_promo.cta_btn": "<a>了解更多</a>",
  "app_promo.cta_link": "https://www.acuvue.com/zh-tw/myacuvue-rewards-benefits/",
}

export default app_promo;
